import Box from '@mui/material/Box';
import styles from '../../Feedback.module.scss';
import classNames from 'classnames/bind';
import { memo } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CloseIcon, StarIcon } from '~/assets/icons';
import { IFeedback } from '~/utils/interface/feedback';
import dayjs from 'dayjs';
import { downloadFile, getFileName } from '~/utils/helper';

const cx = classNames.bind(styles);

type CustomerDetailDialogProps = {
  open: boolean;
  data: IFeedback | undefined;
  setOpen?: (open: boolean, needRefreshData?: boolean) => void;
};

function CustomerDetailDialog(props: CustomerDetailDialogProps) {
  const { t } = useTranslation('admin/feedback');

  const handleSetOpen = (open: boolean, needRefreshData?: boolean) => {
    if (props.setOpen) {
      props.setOpen(open, needRefreshData);
    }
  };

  function renderStarIcon() {
    const stars = [];
    const rating = Number(props?.data?.rate_experience) || 0;

    for (let i = 0; i < rating; i++) {
      stars.push(<StarIcon key={i} fill='#FF9500' className='w-[18px] h-[18px]' />);
    }

    return stars;
  }

  return (
    <Box className={cx('customer-detail-container')}>
      <Dialog open={props.open} onClose={() => handleSetOpen(false)} fullWidth maxWidth='sm'>
        <DialogTitle className='bg-[#005F73]'>
          {t('customerDetailDialog.title')}
          <IconButton onClick={() => handleSetOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box className='w-full'>
            <Box color={'black'}>
              <Typography component={'span'} fontWeight={'bold'}>
                {t('customerDetailDialog.date')}:{' '}
              </Typography>
              <Typography component={'span'}>
                {props?.data?.submit_time ? dayjs(props?.data?.submit_time).format('DD/MM/YYYY') : ''}
              </Typography>
            </Box>
            <Box color={'black'} className='my-4'>
              <Typography component={'span'} fontWeight={'bold'}>
                {t('customerDetailDialog.phone/email')}:{' '}
              </Typography>
              <Typography component={'span'}>{props?.data?.phone_or_email}</Typography>
            </Box>
            <Box color={'black'}>
              <Typography component={'span'} fontWeight={'bold'}>
                {t('customerDetailDialog.type')}:{' '}
              </Typography>
              <Typography component={'span'}>{props?.data?.type_of_feedback}</Typography>
            </Box>
            <Box color={'black'} display={'flex'} alignItems={'center'} className='my-4'>
              <Typography fontWeight={'bold'}>{t('customerDetailDialog.rating')}:</Typography>
              <Typography className='ml-1.5' display={'flex'}>
                {renderStarIcon()}
              </Typography>
            </Box>
            <Box color={'black'}>
              <Typography fontWeight={'bold'}>{t('customerDetailDialog.description')}:</Typography>
              {props.data?.feedback_details && (
                <Typography className='border border-[#005F73] rounded-[8px] mt-2.5 p-2.5'>
                  {props.data?.feedback_details}
                </Typography>
              )}
            </Box>
            <Box color={'black'} className='my-4'>
              <Typography fontWeight={'bold'}>{t('customerDetailDialog.file')}:</Typography>
              {props?.data?.files?.length
                ? props?.data?.files?.map((file: any, index) => (
                    <Box className='flex flex-row gap-2.5' key={index + Date()}>
                      <Button className='block font-normal p-0 h-auto' onClick={() => downloadFile(file.file_url)}>
                        • {getFileName(file.filename)}
                      </Button>
                    </Box>
                  ))
                : ''}
            </Box>
            <Box color={'black'}>
              <Typography fontWeight={'bold'}>{t('customerDetailDialog.proposal')}:</Typography>
              {props?.data?.additional_comments && (
                <Typography className='border border-[#005F73] rounded-[8px] mt-2.5 p-2.5'>
                  {props.data?.additional_comments}
                </Typography>
              )}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}

export default memo(CustomerDetailDialog);
